// extracted by mini-css-extract-plugin
module.exports = {"card-equal-height":"quickEntries_card-equal-height_JLkGT","card-footer":"quickEntries_card-footer_gmM6B"};